export const environment = {
  production: false,
  uri: 'https://dsistemasweb.sefaz.ba.gov.br/sistemas/gpa/api',
  uriSiad: 'https://dwebservices.sefaz.ba.gov.br/webservices/siad/api',
  uriAscas: 'https://dwebservices.sefaz.ba.gov.br/webservices/ASCAS'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts